// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__3vyzx","header":"PatientBlock_header__3xHeq","label":"PatientBlock_label__102QF","option":"PatientBlock_option__3VIpF"};